module.exports = __webpack_public_path__ + "static/clueless-9e9a0c5c721fb0b7fad044ea258ab461.jpg";